export enum ACTION_STATUS {
  "NOT STARTED" = 1,
  "IN PROGRESS",
  COMPLETED,
  CANCELED
}
